import { createSlice } from '@reduxjs/toolkit'
import { TABLE } from 'app/types'
import setupTableHeader from './setupTableHeader'
import setupTableRows from './setupTableRows'

const initialState = {
  dataList: [],
  columns: [],
  rows: []
}
export const tableSlice = createSlice({
  name: TABLE,
  initialState: { ...initialState },
  reducers: {
    setTable: (state, action) => {
      const { headers = [], dataList = [] } = action.payload
      state.dataList = dataList
      state.columns = setupTableHeader(headers)
      state.rows = setupTableRows(dataList)
    },
    clearTable: state => {
      state.dataList = []
      state.columns = []
      state.rows = []
    }
  }
})

export const { setTable, clearTable } = tableSlice.actions
export const selectTableSlice = state => state[TABLE]
export default tableSlice.reducer
